// author : sayed
export default function hasPermission(targetPermissions) {
  const user = JSON.parse(localStorage.getItem("user"));
  const permissionsList = user?.permissions || [];
  const userRole = user?.roleName?.toLowerCase();

  if (userRole === "super admin") return true;

  const permissionsToCheck = Array.isArray(targetPermissions)
    ? targetPermissions
    : [targetPermissions];

  return permissionsToCheck.some((permission) =>
    permissionsList.some(
      (userPerm) => userPerm.name.toLowerCase() === permission.toLowerCase()
    )
  );
}